import { Sparkles } from 'lucide-react';
import { BlocoCampos, CampoArea, CampoTexto, Grade, Interruptor } from '../componentes/campos';
import { ListaTextos } from '../componentes/lista-editavel';
import { novoTexto } from '../manual-defaults';
import { TEXTOS } from '../manual-textos';
import type { PropsSecao } from './tipos';

type CampoTextual = 'transporte' | 'armazenagem' | 'montagem' | 'icamento' | 'ajustes';

const PADROES: { campo: CampoTextual; rotulo: string; padrao: string; descricao: string }[] = [
  { campo: 'transporte', rotulo: 'Transporte (4.1)', padrao: TEXTOS.transporte, descricao: 'Movimentação até o local de instalação.' },
  { campo: 'armazenagem', rotulo: 'Armazenagem (4.2)', padrao: TEXTOS.armazenagem, descricao: 'Condições de guarda quando fora de uso.' },
  { campo: 'montagem', rotulo: 'Montagem e instalação (4.3)', padrao: TEXTOS.instalacao, descricao: 'Fixação, nivelamento, aterramento e liberação.' },
  { campo: 'icamento', rotulo: 'Içamento e elevação (4.4)', padrao: TEXTOS.icamento, descricao: 'Pontos de içamento e acessórios previstos.' },
  { campo: 'ajustes', rotulo: 'Ajustes originais (4.5)', padrao: TEXTOS.ajustes, descricao: 'Parâmetros definidos no comissionamento.' },
];

export function SecaoInstalacao({ editor }: PropsSecao) {
  const { dados, definirCampo, definirOpcao, adicionarItem, atualizarItem, removerItem, moverItem } = editor;

  return (
    <>
      <BlocoCampos titulo="Procedimentos de instalação" descricao="Estes campos já vêm com o texto padrão do template. Edite o que for específico da máquina; “Restaurar texto padrão” desfaz a edição.">
        {PADROES.map((item) => (
          <div key={String(item.campo)} className="manual-campo-padrao">
            <CampoArea
              rotulo={item.rotulo}
              dica={item.descricao}
              linhas={4}
              valor={dados[item.campo]}
              placeholder={item.padrao}
              aoMudar={(valor) => definirCampo(item.campo, valor)}
            />
            <button
              type="button"
              className="manual-ghost-button"
              onClick={() => definirCampo(item.campo, item.padrao)}
            >
              <Sparkles />Restaurar texto padrão
            </button>
          </div>
        ))}
      </BlocoCampos>

      <BlocoCampos titulo="Requisitos do local" descricao="Condições que o local de instalação deve atender (item 4.3).">
        <ListaTextos
          itens={dados.requisitosLocal}
          multilinha
          placeholder="Ex.: Piso nivelado com resistência mínima compatível com o peso da máquina."
          rotuloAdicionar="Adicionar requisito"
          vazio="Nenhum requisito cadastrado."
          aoAdicionar={() => adicionarItem('requisitosLocal', novoTexto())}
          aoAtualizar={(id, patch) => atualizarItem('requisitosLocal', id, patch)}
          aoRemover={(id) => removerItem('requisitosLocal', id)}
          aoMover={(id, direcao) => moverItem('requisitosLocal', id, direcao)}
          sugestoes={[
            'Piso nivelado, plano e com resistência compatível com o peso da máquina.',
            'Espaço livre para circulação e manutenção em todo o perímetro.',
            'Iluminação adequada no posto de trabalho.',
            'Ponto de energia dimensionado conforme a especificação elétrica.',
            'Área delimitada e sinalizada.',
          ]}
          aoEscolherSugestao={(valor) => adicionarItem('requisitosLocal', novoTexto(valor))}
        />
      </BlocoCampos>

      <BlocoCampos titulo="Assistência técnica" descricao="Item 4.6 — pode ser removido do documento nas opções abaixo.">
        <Interruptor
          rotulo="Incluir o item de assistência técnica"
          descricao="Quando desligado, o capítulo 4 encerra em Ajustes originais."
          ativo={dados.opcoes.incluirAssistencia}
          aoMudar={(ativo) => definirOpcao('incluirAssistencia', ativo)}
        />
        {dados.opcoes.incluirAssistencia && (
          <>
            <CampoArea
              rotulo="Orientação de assistência técnica"
              linhas={3}
              valor={dados.assistencia}
              placeholder={TEXTOS.assistencia}
              aoMudar={(valor) => definirCampo('assistencia', valor)}
            />
            <Grade>
              <CampoTexto
                largo
                rotulo="Contato para assistência"
                valor={dados.assistenciaContato}
                placeholder="Setor, telefone ou e-mail"
                aoMudar={(valor) => definirCampo('assistenciaContato', valor)}
              />
            </Grade>
          </>
        )}
      </BlocoCampos>
    </>
  );
}
